// import React, { useState } from "react"; //Importing React
// import { addNewArtist, modifyArtists, readSingleArtist } from "./Components/FirestoreDB"

const News: React.FC = () => {
	return <section id="News"></section>;
};

export default News;
